/* global axios */
import ApiClient from '../ApiClient';

class NexceoSourceRulesAPI extends ApiClient {
  constructor() {
    super('nexceo/projects', { accountScoped: true });
  }

  list(projectId) {
    return axios.get(`${this.url}/${projectId}/source_rules`);
  }

  get(projectId, ruleId) {
    return axios.get(`${this.url}/${projectId}/source_rules/${ruleId}`);
  }

  create(projectId, data) {
    return axios.post(`${this.url}/${projectId}/source_rules`, {
      source_rule: data,
    });
  }

  update(projectId, ruleId, data) {
    return axios.put(`${this.url}/${projectId}/source_rules/${ruleId}`, {
      source_rule: data,
    });
  }

  destroy(projectId, ruleId) {
    return axios.delete(`${this.url}/${projectId}/source_rules/${ruleId}`);
  }
}

export default new NexceoSourceRulesAPI();
